// extracted by mini-css-extract-plugin
export default {"content":"checklist-item-delete_content__oc75G","buttons":"checklist-item-delete_buttons__HiFOC","button":"checklist-item-delete_button__yrL9i"};